module.exports = __webpack_public_path__ + "img/farzana-christopher-139.6951adec.jpg";